<template>
  <div class="home-tab">
    <img src="../assets/images/Logo.png" alt class="logo" @click="goHome">
    <el-menu
      :default-active="activeIndex"
      class="el-menu-demo"
      mode="horizontal"
      background-color="#070784"
      text-color="#fff"
      active-text-color="#070784"
      active-background-color="#fff"
      :router="true"
    >
      <el-menu-item index="home" route="home">首页</el-menu-item>
      <el-menu-item index="cooperation" route="cooperation">合作指南</el-menu-item>
      <el-menu-item index="API" route="API">API文档</el-menu-item>
      <el-menu-item index="Help" route="Help">帮助支持</el-menu-item>
    </el-menu>
      <a class="btn" @click="showContact = true">申请合作</a>

    <contact :showDialog.sync="showContact"></contact>
  </div>
</template>
<script>
import contact from "../components/contact.vue";
export default {
  components: {
    contact
  },
  data() {
    return {
      showContact: false
    };
  },
  props: {
    activeIndex: {
      type: String,
      default: 'home'
    }
  },
  methods: {
    goHome() {
      this.$router.push({
          path: '/home'
        })
    }
  }
};
</script>
<style lang="scss">
// 一级标题
.el-menu--horizontal {
  border: none;
  .el-menu {
    min-width: 112px !important;
    background-color: #fff !important;
    .el-menu-item {
      background-color: #fff !important;
      color: #212121 !important;
      font-size: 18px;
      height: 65px !important;
      line-height: 65px !important;
      text-align: center;
    }
  }
  .el-submenu {
    .el-submenu__title {
      height: 80px !important;
      line-height: 80px !important;
      border-bottom: 2px solid transparent;
      color: #fff;
      font-size: 18px;
      &:hover {
        background-color: rgba(255, 255, 255, 0.2) !important;
      }
      i {
        color: #fff;
      }
    }
  }
  .el-menu-item {
    &:hover {
      background-color: rgba(255, 255, 255, 0.2) !important;
    }
  }
  .is-active {
    .el-submenu__title {
      color: rgb(7, 7, 132)!important;
      background-color: #fff !important;
      border: none !important;
      &:hover{
        background-color: #fff !important;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.home-tab {
  height: 80px;
  overflow: hidden;
  width: 100%;
  background-color: rgb(7, 7, 132);
  .logo {
    display: inline;
    float: left;
    margin: 20px 100px 20px 40px;
  }
  .el-menu-demo {
    display: inline-block;
    .el-menu-item.is-active {
      background-color: #fff !important;
      border-bottom-color: #fff !important;
      font-weight: bold;
    }
    .el-menu-item {
      height: 80px;
      line-height: 80px;
      font-family: PingFangSC-Regular;
      font-size: 18px;
      border: none;
    }
  }
  .btn {
    display: inline-block;
    float: right;
    margin: 20px 40px 0 0;
    color: #fff;
    border: 1px solid #fff;
    font-size: 18px;
    width: 120px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    border-radius: 2px;
    &:hover {
      background: rgba(255,255,255,0.20);
    }
  }
}
</style>
